import {objectFromEntries} from "../util/arutil.tsx";
import {iconForEntityType} from "../fa.tsx";
import {z} from "zod/v4";

export const dispatchFacetEntities = ["truck", "bundle"] as const;
export const DispatchFacetEntity = z.enum(dispatchFacetEntities);

export type DispatchFacetEntity = z.infer<typeof DispatchFacetEntity>;
export const dispatchFacetIcons = objectFromEntries(dispatchFacetEntities.map(name => {
    const entry = [name, iconForEntityType(name).icon] as const;
    return entry;
}));

